import { call, put, select } from 'redux-saga/effects'
import { getPersonProfile } from '../api'
import { SEND_INFO_TO_JIVO_CHAT } from '../ducks/tools'
import { loadScript } from '../helpers/useScript'
import { JIVO_TOKEN } from '../config'

export const moduleName = 'profile'
export const PROFILE_INFO_SET = `${moduleName}/PROFILE_INFO_SET`

const initialState = {}

export default function reducer(state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case PROFILE_INFO_SET:
      return {
        ...state,
        ...payload
      }

    default:
      return state
  }
}

export const fetchPersonProfileSaga = function*() {
  try {
    const response = yield call(getPersonProfile)

    yield put({
      type: PROFILE_INFO_SET,
      payload: response
    })

    const { properties } = yield select((state) => state)

    const enable = properties.entities[0].enableLiveChat

    if (enable) {
      loadScript(`//code.jivo.ru/widget/${JIVO_TOKEN}`, () => {})
      yield put({
        type: SEND_INFO_TO_JIVO_CHAT
      })
    }
  } catch (e) {
    console.log('error', e)
  }
}
